//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchLoader from "./components/loader/Loader.vue";
export default {
  name: "BlueSearch",
  components: { SearchLoader },
  data() {
    return {
      preSearch: null
    }
  },
  computed: {
    reloading() {
      return this.$store.getters.reloading;
    },
    loaded() {
      return this.$store.getters.loaded && !this.$store.getters.errored;
    },
    errored() {
      return this.$store.getters.errored;
    },
    errorType() {
      return this.$store.getters.errorType;
    },
    errorData() {
      return this.$store.getters.errorData;
    },
    results() {
      return this.$store.getters.results;
    },
    extended() {
      return this.$store.getters.extended;
    },
  },
  methods: {
    executeSearch(callback) {
      return this.$store.dispatch("executeSearch", callback);
    },
    extend(callback) {
      this.$store.commit("extend", callback);
    },
  },
  created() {
    this.$store.commit("applyOptions", this.options);
    this.$store.commit("parseInitialQueryParams");

    if (!this.options.allowPreSearch) return;

    this.preSearch = new Promise(resolve => {
      let isResolved = false;
      const done = () => {
        isResolved = true;
        resolve();
      };

      this.$emit('presearch', {
        done,
        extend: this.extend,
        extended: this.extended
      });

      setTimeout(() => {
        if (!isResolved) {
          done();
        };
      }, 1500);
    });
  },
  async mounted() {
    if (this.options.allowPreSearch) {
      await this.preSearch;
    }
    this.$store.dispatch("executeSearch");
  },
};
